
export const isAuthenticated = state => {
    return (state.user != null && state.user.id > 0);
};

export const getPermissions = (state, getters) => {
    let user = getters.getUser;

    return (user === null ? {} : state.user.permissions);
};

export const hasPermission = (state, getters) => (permission) => {
    let perms = getters.getPermissions;

    return (perms.hasOwnProperty(permission) && perms[permission] === true);
};

export const getUser = (state, getters) => {
    return (getters.isAuthenticated ? state.user : null);
};

export const getSensors = (state, getters) => {
    return (getters.isAuthenticated ? state.sensors : null);
};

export const getContacts = (state, getters) => {
    return (getters.isAuthenticated ? state.contacts : null);
};

export const getFirmwareHistory = (state, getters) => {
    return state.firmware_versions;
};

export const getContact = (state, getters) => (id) => {
    return (getters.isAuthenticated ? state.contacts.find(contact => contact.id === id) : null);
};

export const getAlertingContacts = (state, getters) => {
    return (getters.isAuthenticated ? state.alerting_contacts : null);
};

export const getAlertingContact = (state, getters) => (id) => {
    return (getters.isAuthenticated ? state.alerting_contacts.find(contact => contact.id === id) : null);
};

export const getContextUser = (state, getters) => {
    return (getters.isAuthenticated ? state.context : null);
};

export const getContextPermissions = (state, getters) => {
    let user = getters.getContextUser;
    return (user !== null ? user.permissions : {});
};

export const hasContextPermission = (state, getters) => (permission) => {
    let perms = getters.getContextPermissions;

    return (perms.hasOwnProperty(permission) && perms[permission] === true);
};

export const hasTargetContextPermission = (state, getters) => (permission) => {
    let perms = getters.getTargetContext.permissions;

    return (perms.hasOwnProperty(permission) && perms[permission] === true);
};

export const getTargetContext = (state, getters) => {
    return (getters.getContextUser || getters.getUser);
};

export const getContextPath = (state, getters) => {
    return (getters.isAuthenticated ? state.contextPath : []);
};




// WEBPACK FOOTER //
// ./src/store/getters.js